import { AgentDefCrudService } from "../../apis/mgmt/AgentDefCrudService";
import { AgentDef } from "../../apis/mgmt/api";
import { EditableProps, useStatefulApiEditable } from "../common/Editable";
import { ListProps } from "../common/List";
import { ToggleableProps, useStatefulToggleable } from "../common/Toggleable";
import { AgentAdaptersAndTasks } from "./AgentAdaptersAndTasks";
import { AgentDefEditable } from "./AgentDefEditable";
import { AgentDefEditableModal } from "./AgentDefEditableModal";
import { AgentDefFilteredList, useAgentDefFilteredList } from "./AgentDefFilteredList";
import { AgentPageLayout } from "./AgentPageLayout";

export function useAgentPage(props: {
    listProps: ListProps<AgentDef>,
    toggle: ToggleableProps,
    editableProps: EditableProps<AgentDef>,
    toggleForm: ToggleableProps,
    editableFormProps: EditableProps<AgentDef>,
    defaultAddItemData?: AgentDef
}) {

    const { listProps, toggle, editableProps, toggleForm, editableFormProps } = props;

    listProps.onAddItem = () => {
        editableFormProps.edit(props.defaultAddItemData);
        toggleForm.show();
    };

    listProps.onEditItem = (item: AgentDef) => {
        editableProps.edit(item);
        toggle.show();
    };

    editableFormProps.onSaved = (item: AgentDef, hideAfterSaving: boolean) => {
        listProps.setItem(item);
        if (hideAfterSaving) toggleForm.hide();
    };

    editableFormProps.onDeleted = (item: AgentDef) => {
        listProps.deleteItem(item);
        toggleForm.hide();
    };

    return props;
}

export const AgentPage = function () {

    const { filterProps, listProps, pagingProps} = useAgentDefFilteredList();

    const toggle = useStatefulToggleable(false);
    const editableProps = useStatefulApiEditable(AgentDefCrudService, undefined, undefined, toggle);

    const toggleForm = useStatefulToggleable(false);
    const editableFormProps = useStatefulApiEditable(AgentDefCrudService, undefined, undefined, toggleForm);

    useAgentPage({ listProps, editableProps, editableFormProps, toggle, toggleForm });

    return (
        <AgentPageLayout
            list={<AgentDefFilteredList {...{ filterProps, listProps, pagingProps }} />}
            toggle={toggle}
            detail={<AgentAdaptersAndTasks  {...editableProps} toggle={toggle} editableForm={editableFormProps}/>}
            detailModal={<AgentDefEditableModal {...editableFormProps}  toggle={toggleForm} />}
        />
    );

};
